import { intellisense, IntellisenseExpectedType } from './intellisense';
import { string } from './type-checkers';

const expression = intellisense(string, IntellisenseExpectedType.EXPRESSION)
  .group('expressions');

export {
  expression,
};
